// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnrollmentIsValidMemberNumberModel {
    static getAttributeTypeMap() {
        return EnrollmentIsValidMemberNumberModel.attributeTypeMap;
    }
}
EnrollmentIsValidMemberNumberModel.discriminator = undefined;
EnrollmentIsValidMemberNumberModel.additionalProperties = false;
EnrollmentIsValidMemberNumberModel.attributeTypeMap = [
    {
        "name": "memberNumber",
        "baseName": "memberNumber",
        "type": "string"
    },
    {
        "name": "isValid",
        "baseName": "isValid",
        "type": "boolean"
    },
    {
        "name": "validationMessage",
        "baseName": "validationMessage",
        "type": "string"
    },
    {
        "name": "inUse",
        "baseName": "inUse",
        "type": "boolean"
    },
    {
        "name": "memberNumberType",
        "baseName": "memberNumberType",
        "type": "EnrollmentType"
    },
];
//# sourceMappingURL=enrollmentIsValidMemberNumberModel.js.map